import { render, staticRenderFns } from "./GlobalTitle.vue?vue&type=template&id=592a7476&name=global-title&"
import script from "./GlobalTitle.vue?vue&type=script&lang=js&"
export * from "./GlobalTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports